<template>
    <div class="main_container">
        <div class="layout_split">
                <RightWing :index="6" :score="score" />
                <div class="main_area">

                    <div class="upper_flex_container">
                        <div class="result_container" style="width:270px;">
                            <div class="black_label">팩트체커</div>
                            <div class="result_value">{{playerName}}</div>
                        </div>
                        <div class="result_container" style="width:270px;">
                            <div class="black_label">최종점수</div>
                            <div class="result_value">{{score}}점</div>
                        </div>
                        <div class="result_container" style="width:270px;">
                            <div class="black_label">최종레벨</div>
                            <div class="result_value">팩트체커 {{rank}}급</div>
                        </div>
                    </div>

                    <div class="lower_flex_container">
                        <div class="result_container" style="width:320px; overflow:auto;">
                            <div class="black_label">완료주제</div>
                            <div style="height:190px; overflow:auto; padding:10px;">
                                <div v-for="(article, index) in completeArticles" :key="index" class="result_list_value">
                                    {{article}}
                                </div>
                            </div>
                        </div>
                        <div class="result_container" style="width:320px;">
                            <div class="black_label">최종결과</div>
                            <div style="height:190px; overflow:auto; padding:10px;">
                                <div class="result_value">
                                    시도회수: {{tryCount}}회<br>
                                    글쓴이 구분력: {{authorPower}}%<br>
                                    출처 구분력: {{refPower}}%<br>
                                    작성일 구분력: {{timePower}}%<br>
                                    논리 구분력: {{logicPower}}%<br>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="btn_container">
                        <div class="btn_ok btn_ok_active" @click="makePdf">결과 다운로드 받기</div>
                    </div>

                    <div v-if="!endGame" class="btn_container">
                        <div class="btn_ok btn_ok_active" @click="backToPlay">게임으로 돌아가기</div>
                    </div>
                    <div class="mobile_margin">space</div>

                </div>
        </div>
    </div>
</template>

<script>
/*** 웹폰트 사용 가능한 경우 
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
***/

// 웹폰트 사용 불가능한 경우
import pdfMake from '../pdf/pdfmake'
import vfs from '../pdf/vfs_fonts' // pdf에 사용할 64BaseIncoded가상폰트데이터

import RightWing from '../components/RightWingView.vue'


const PAPER_WIDTH = 595.28;
const PAPER_HEIGHT = 841.89;//700;
const PAPER_MARGIN_W = 40;
const PAPER_MARGIN_H = 60;
const PAGE_WIDTH = PAPER_WIDTH - (PAPER_MARGIN_W * 2);
//const PAGE_HEIGHT = PAPER_HEIGHT - (PAPER_MARGIN_H * 2);

const BIG_TITLE_HEIGHT = 60;
const TBL_TITLE_TOP_MARGIN = 10;
//const TBL_TITLE_H = TBL_TITLE_TOP_MARGIN + 12 * 1;
//const TBL_BLANK_ROW_H = 25;
const TBL_CONTENT_TOP_MARGIN = 25;  
const TBL_CONTENT_BOTTOM_MARGIN = 10;
const ARTICLE_GAP_Y = 40;
const MAX_ARTICLE_PER_PAGE = 4;
const FONT_HEIGHTS = {
    "default": 1.2,
    "result": 2,
    "article": 1.2
};
const FONT_SIZE = 11;

const BOX_HEIGHTS = {
    "small": 80,
    "medium": 165,
    "article": 150
}

export default {
    name: 'FinalResultView',

    components: {
        'RightWing': RightWing
    },

    data() {
        return {
            currentPlay: null,
            playerName: null,
            score: null,
            rank: null,
            completeArticles: null,
            completeArticlesForPrint: [],
            tryCount: 0,
            authorPower: 0,
            refPower: 0,
            timePower: 0,
            logicPower: 0,
        }
    },

    mounted() {
        this.currentPlay = this.$getCurrentGame()
        // console.log(this.currentPlay)
        this.playerName = this.currentPlay.player_name
        this.score = this.currentPlay.score
        this.rank = 9 - Math.floor(this.score / 2000)
        this.tryCount = this.currentPlay.num_of_factcheck
        if(this.rank < 1) {
            this.rank = 1
        }
        if(this.currentPlay.author_try == 0) {
            this.authorPower = 0
        }
        else {
            this.authorPower = Math.round(this.currentPlay.author_correct * 100 / this.currentPlay.author_try)
        }
        if(this.currentPlay.ref_try == 0) {
            this.refPower = 0
        }
        else {
            this.refPower = Math.round(this.currentPlay.ref_correct * 100 / this.currentPlay.ref_try)
        }
        if(this.currentPlay.time_try == 0) {
            this.timePower = 0
        }
        else {
            this.timePower = Math.round(this.currentPlay.time_correct * 100 / this.currentPlay.time_try)
        }
        if(this.currentPlay.logic_try == 0) {
            this.logicPower = 0
        }
        else {
            this.logicPower = Math.round(this.currentPlay.logic_correct * 100 / this.currentPlay.logic_try)
        }
        
        this.makeCompleteArticles()
        this.makeCompleteArticlesForPrint()
    },

    computed: {
        endGame: function() {
            if(this.currentPlay == null) {
                return true
            }
            const start_time = this.currentPlay.start_time
            let delta = (30 * 60) - ((Date.now() - start_time) / 1000)
            if(delta <= 0) {
                return true
            }
            return false
        }
    },

    methods: {
        // logging: function() {
        //     // TODO 로깅 테스트 코드, 나중에 위치를 옮기고 최종에는 제거해야 한다
        //     let urlstr = ''
        //     let params = {'data': this.$get('games')}
        //     this.$http.post(urlstr, params).then((result) => {
        //         console.log(result)
        //     }).catch((err) => {
        //         console.log(err)
        //     });
        // },

        makeCompleteArticlesForPrint: function() {
            this.completeArticlesForPrint = [[]]
            let completeArticleCount = 0
            if(this.currentPlay.articles == undefined) {
                return
            }
            // console.log(this.currentPlay.articles)
            for(let i = 0; i < this.currentPlay.articles.length; i++) {
                let article = this.currentPlay.articles[i]
                // console.log(article.playerResult)
                // console.log(i + ' :: ' + article.title)
                if(article.playerResult == undefined) {
                    continue
                }
                
                // console.log('pass: ' + article.title)
                if(completeArticleCount == 0 || completeArticleCount == 1) {
                    this.completeArticlesForPrint[0].push(
                        {'title': article.title + ' <' + article.correctResult + '>',
                        'content': article.desc, 'result': article.correctResult})
                    // console.log(this.completeArticlesForPrint)
                }
                else {
                    // 0:::: 0, 1
                    // 1:::: 2, 3, 4, 5
                    // 2:::: 6, 7, 8, 9
                    // let target = 1 + Math.floor((i - 2) / 4)
                    let target = 1 + Math.floor((completeArticleCount - 2) / 4)
                    // console.log(i + '/' + target)
                    // console.log(this.completeArticlesForPrint)
                    // console.log(this.completeArticlesForPrint[target])
                    
                    if(this.completeArticlesForPrint[target] == undefined) {
                        this.completeArticlesForPrint.push([])
                    }
                    this.completeArticlesForPrint[target].push(
                        {'title': article.title + ' <' + article.correctResult + '>',
                        'content': article.desc, 'result': article.correctResult})
                }
                completeArticleCount = completeArticleCount + 1
            }
            // console.log(this.completeArticlesForPrint)
        },

        makeCompleteArticles: function() {
            this.completeArticles = []
            // console.log(this.currentPlay.articles)
            if(this.currentPlay.articles == undefined) {
                return
            }
            for(let i = 0; i < this.currentPlay.articles.length; i++) {
                let article = this.currentPlay.articles[i]
                if(article.playerResult == undefined) {
                    continue
                }            
                this.completeArticles.push(article.title)
            }
        },

        ///////////////////////
        // pdfmaker에서 font나 이미지 데이터 등을 사용하기 위한 가상파일 시스템 설정 
        ///////////////////////
        setupPdfMaker: function() {
            pdfMake.vfs = vfs;
            pdfMake.addVirtualFileSystem(vfs); 
            pdfMake.fonts = {      
                GmarketSans: {
                    normal: 'GmarketSansMedium.otf',
                    bold: 'GmarketSansBold.otf'
                }
            };

            /*//웹폰트 사용시  -- 이 웹폰트는 공백이 x박스로 나와서 사용하지 않음.
            pdfMake.vfs = pdfFonts.pdfMake.vfs;
            pdfMake.fonts = {
                GmarketSans: {
                    bold: 'https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_2001@1.1/GmarketSansBold.woff',
                    normal: 'https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_2001@1.1/GmarketSansMedium.woff'
                }
            }
            */
        },

        ////////////////////////
        // pdf 만들기
        ///////////////////////
        makePdf: function() {
            this.setupPdfMaker()

            let docDefinition = {
                alignment: 'center',
                background: function () { // 연회색 바탕 깔기
                    return {
                        canvas: [
                            {
                                type: 'rect',
                                x: 0, y: 0, w: PAPER_WIDTH, h: PAPER_HEIGHT,//841.89,
                                //x: PAPER_MARGIN_W, y: PAPER_MARGIN_H, w: PAGE_WIDTH, h: PAGE_HEIGHT,//841.89,              
                                color: 'lightgray'
                            }
                        ]
                    };
                },
                defaultStyle: {
                    font: 'GmarketSans', //'NanumGothic'
                },
                content: [
                    {
                        text: '팩트체크 사실 혹은 거짓',
                        //image: 'game_logo.png', fit: [113, 36],
                        alignment: 'center',
                        fontSize: 30,
                    },
                    
                    {  // 팩트체커 배경
                        absolutePosition: {
                            x: PAPER_MARGIN_W,
                            y: PAPER_MARGIN_H + BIG_TITLE_HEIGHT
                        },
                        canvas: this.getBox(PAGE_WIDTH / 3 - 10, BOX_HEIGHTS['small'])
                    },
                    {  // 최종점수 배경
                        absolutePosition: {
                            x: PAPER_MARGIN_W + PAGE_WIDTH / 3 * 1 + 5,
                            y: PAPER_MARGIN_H + BIG_TITLE_HEIGHT
                        },
                        canvas: this.getBox(PAGE_WIDTH / 3 - 10, BOX_HEIGHTS['small'])
                    },
                    {   // 최종레벨 배경
                        absolutePosition: {
                            x: PAPER_MARGIN_W + PAGE_WIDTH / 3 * 2 + 10,
                            y: PAPER_MARGIN_H + BIG_TITLE_HEIGHT
                        },
                        canvas: this.getBox(PAGE_WIDTH / 3 - 10, BOX_HEIGHTS['small'])
                    },
                    
                    {   // 최종결과 배경
                        absolutePosition: {
                            x: PAPER_MARGIN_W,
                            y: PAPER_MARGIN_H + BIG_TITLE_HEIGHT + BOX_HEIGHTS['small'] + 35
                        },
                        canvas: this.getBox(PAGE_WIDTH, BOX_HEIGHTS['medium'])
                    },
                    {   // 데이터 테이블
                        absolutePosition: {
                            x: PAPER_MARGIN_W,
                            y: PAPER_MARGIN_H + BIG_TITLE_HEIGHT
                        },
                        alignment: 'center',
                        //layout: 'noBorders', // noBorders로 하면 y좌표가 흐트러지므로 각 셀에서 보더를 끈다.
                        table: {
                            alignment: 'center',
                            widths: ['*', '*', '*'],
                            body: [
                                [
                                    {
                                        text: "팩트체커",
                                        alignment: 'center',
                                        color: 'white',
                                        background: 'black',
                                        margin: [0, TBL_TITLE_TOP_MARGIN, 10, 0],
                                        bold: true,
                                        fontSize: FONT_SIZE,
                                        border: [false, false, false, false]
                                    },
                                    {
                                        text: "최종점수",
                                        alignment: 'center',
                                        color: 'white',
                                        background: 'black',
                                        marginTop: TBL_TITLE_TOP_MARGIN,
                                        bold: true,
                                        fontSize: FONT_SIZE,
                                        border: [false, false, false, false]

                                    },
                                    {
                                        text: "최종레벨",
                                        alignment: 'center',
                                        color: 'white',
                                        background: 'black',
                                        margin: [10, TBL_TITLE_TOP_MARGIN, 0, 0],
                                        bold: true,
                                        fontSize: FONT_SIZE,
                                        border: [false, false, false, false]
                                    }
                                ],
                                [
                                    {
                                        alignment: 'center',   
                                        text: this.getDocDefinition()['fact_checker'],
                                        color: 'black',
                                        background: 'white',
                                        lineHeight: 1.2,
                                        margin: [10, TBL_CONTENT_TOP_MARGIN, 10, TBL_CONTENT_BOTTOM_MARGIN],
                                        fontSize: 12,
                                        border: [false, false, false, false]
                                    },
                                    {
                                        alignment: 'center',                                    
                                        text:this.getDocDefinition()['score'],
                                        color: 'black',
                                        background: 'white',
                                        lineHeight: 1.2,
                                        margin: [10, TBL_CONTENT_TOP_MARGIN, 10, TBL_CONTENT_BOTTOM_MARGIN],
                                        fontSize: 12,
                                        border: [false, false, false, false]
                                    },
                                    {
                                        alignment: 'center',   
                                        text:this.getDocDefinition()['level'],
                                        color: 'black',
                                        background: 'white',
                                        lineHeight: 1.2,
                                        margin: [10, TBL_CONTENT_TOP_MARGIN, 10, TBL_CONTENT_BOTTOM_MARGIN],
                                        fontSize: 12,
                                        border: [false, false, false, false]
                                    },
                                ],
                                [      // blank
                                    {
                                        text: "",
                                        marginTop: 30,
                                        colSpan: 3,
                                        border: [false, false, false, false]
                                    }
                                ],
                                [
                                    {   
                                        marginTop: TBL_TITLE_TOP_MARGIN,
                                        text: "최종결과",
                                        alignment: 'center',
                                        color: 'white',
                                        background: 'black',  
                                        bold: true,
                                        fontSize: FONT_SIZE,
                                        colSpan: 3,
                                        border: [false, false, false, false],
                                        height: BOX_HEIGHTS['medium']
                                    }                    
                                ],
                                [
                                    {   
                                                                            
                                        alignment: 'center',   
                                        text: this.getDocDefinition()['trial_count'],
                                        color: 'black',
                                        background: 'white',
                                        lineHeight: FONT_HEIGHTS['result'],
                                        margin: [10, TBL_CONTENT_TOP_MARGIN, 10, TBL_CONTENT_BOTTOM_MARGIN],
                                        fontSize: FONT_SIZE,
                                        colSpan: 3,
                                        border: [false, false, false, false]
                                    }     
                                ],
                            ]
                        },             
                    }
                ],
                pageMargins: [ PAPER_MARGIN_W, PAPER_MARGIN_H, PAPER_MARGIN_W, PAPER_MARGIN_H],
                // 페이지 크기 용지의 크기 사이즈 넣기 또는 특정 사이즈 넣기 { width: number, height: number }
                pageSize: 'A4',  //[595.28, 841.89]
                pageOrientation: 'portrait',
            }

            ///// 완료 기사 추가 //////
            // 1번째 페이지 아래 두개
            for (let i = 0; i < this.getDocDefinition()['articles'][0].length ; i++) {
                    let position = i + 2;
                    let pageBreak = position == MAX_ARTICLE_PER_PAGE - 1 && 0 < this.getDocDefinition()['articles'].length - 1 ? 'after': null;
                    this.pushArticle(docDefinition, position, this.getDocDefinition()['articles'][0][i]['title'], this.getDocDefinition()['articles'][0][i]['content'], pageBreak)
            }
            
            // 2번째 페이지부터 마지막 페이지까지.
            for(let page = 1; page < this.getDocDefinition()['articles'].length; page++) {
                //- 배경추가
                for (let i = 0; i < this.getDocDefinition()['articles'][page].length ; i++) {
                    let pageBreak = i == MAX_ARTICLE_PER_PAGE - 1 && page < this.getDocDefinition()['articles'].length - 1 ? 'after': null;
                    this.pushArticle(docDefinition, i, this.getDocDefinition()['articles'][page][i]['title'], this.getDocDefinition()['articles'][page][i]['content'], pageBreak)
                }
            }

            pdfMake.createPdf(docDefinition).download();

            // this.logging()
        },


        ///////////////////////////////////////////
        // 검정 타이틀 + 흰색 내용 박스 배경을 정의한다.
        ///////////////////////////////////////////
        getBox: function(width, height) {
            const SHADOW_THICK = 4;
            const TITLE_WIDTH = 120;
            const TITLE_HEIGHT = 40;

            let titlePosX = (width - TITLE_WIDTH) / 2;
            let titleBox = {
                type: 'polyline',
                closePath: true,
                color: 'black',
                points: [
                    { x: titlePosX + SHADOW_THICK, y: SHADOW_THICK / 2 }, 
                    { x: titlePosX + TITLE_WIDTH, y: 0 }, 
                    { x: titlePosX + TITLE_WIDTH - SHADOW_THICK, y: TITLE_HEIGHT - (SHADOW_THICK / 2) }, 
                    { x: titlePosX + 0, y: TITLE_HEIGHT }
                ]
            }
            let shadow = JSON.parse(JSON.stringify(titleBox)); //copy
            shadow['color'] = 'darkgray';
            for (let i = 0; i < shadow['points'].length ; i++) {
                shadow['points'][i].x += SHADOW_THICK;
                shadow['points'][i].y += SHADOW_THICK;
            }
            return [
                    { // content box
                        type: 'rect',
                        x: 0,
                        y: 20, // 타이틀 박스 중 컨텐츠박스에 속하지 않은 부분
                        w: width, 
                        h: height - 20, // 전체 영역에서 타이틀의 1/2 부분 뺀 만틈이 컨텐츠 영역의 높이이므로 
                        r: 0,
                        color: 'white',
                    },
                    shadow,
                    titleBox,
            ]
        },

        ////////////////////////////////////////////
        // 문서정의에 완료기사(배경과 데이터) 한개를 추가한다.
        ///////////////////////////////////////////
        pushArticle: function(docDefinition, position, title, content, pageBreak) {
            // 완료기사 배경 추가
            docDefinition['content'].push({
                absolutePosition: {
                    x: PAPER_MARGIN_W,
                    y: PAPER_MARGIN_H + position * BOX_HEIGHTS['article'] + position * ARTICLE_GAP_Y
                },
                canvas: this.getBox(PAGE_WIDTH, BOX_HEIGHTS['article'])                    
            })
            // 완료기사 문자 데이터 추가
            docDefinition['content'].push({
                absolutePosition: {
                    x: PAPER_MARGIN_W,
                    y: PAPER_MARGIN_H + position * BOX_HEIGHTS['article'] + position * ARTICLE_GAP_Y
                },
                margin: [10, TBL_CONTENT_TOP_MARGIN, 10, TBL_CONTENT_BOTTOM_MARGIN],
                layout: 'noBorders',
                table: {
                    widths: ['*'],
                    body: [
                        [{   
                            marginTop: TBL_TITLE_TOP_MARGIN,
                            text: "완료주제",
                            alignment: 'center',
                            color: 'white',
                            background: 'black',  
                            bold: true,
                            fontSize: FONT_SIZE,
                        }],
                        [{
                            margin: [10, TBL_CONTENT_TOP_MARGIN, 10, 0],
                            text: title,
                            color: 'black',
                            background: 'white',
                            alignment: 'center',
                            lineHeight: FONT_HEIGHTS['article'],
                            fontSize: FONT_SIZE,
                            bold: true
                        }],
                        [{
                            margin: [10, 10, 10, 0],
                            text: content,
                            color: 'black',
                            background: 'white',
                            alignment: 'left',
                            lineHeight: FONT_HEIGHTS['article'],
                            fontSize: FONT_SIZE
                        }]

                    ]
                },
                pageBreak: pageBreak
            })
        },

        getDocDefinition: function() {
            return {
                "fact_checker": this.playerName,
                "score": this.score + '점',
                "level": '팩트체커' + this.rank + '급',
                "trial_count": "시도회수: " + this.tryCount + "회\n◎글쓴이 구분력: " + this.authorPower + "%   ◎출처 구분력: " + this.refPower + "%\n◎작성일 구분력: " + this.timePower + "%   ◎논리 구분력: " + this.logicPower + "%",
                "articles": this.completeArticlesForPrint
                // "articles": [
                //     // 1페이지  --- 하단에 기사 2개만 들어갈 수 있다.
                //     [
                //         {
                //             title: '이웃집에서 만든 눈사람, 부수면 벌금 낸다.',
                //             content: "2020년 겨울, SNS로 다양한 눈사람 인증 사진이 인기를 얻던 순간. 대전의 한 카페 앞에 있던 '엘사 눈사람'이 화제였다. 하지만 한 남성이 눈사람을 훼손한 CCTV 영상이 공개되며 해당 남성에 대한 처벌 여부에 대한 논란이 있다."
                //         },
                //         {
                //             title: '전자레인지로 음식을 조리하면 영양소가 파괴된다. 1',
                //             content: "영양소가 파괴되는 것이 아니냐는 불안감의 목소리도 커지고 있다. 아니라고 한다.",
                //         }  
                //     ],
                //     // 2페이지  --- 2페이지부터는 기사가 최대 4개
                //     [
                //         {
                //             title: '고춧가루는 조선시대 임진왜란 당시 일본군을 통해 들어왔기 때문에 그 전에 김치는 없었다.',
                //             content: "우리나라의 대표적인 음식으로 김치는 많은 사랑을 받고 있고, 세계적으로도 인기가 있다. 김치가 인기가 많아지면서 김치에 대한 유래, 역사적 근원에 대한 관심이 이어지고 있다.",
                //         },
                //         {
                //             title: '코로나19 백신 접종 후 사망할 확률이 독감 백신 보다 2배 이상 높다.',
                //             content: "코로나19 바이러스에 대한 불안감이 오래 가면서 백신에 대한 기대감이 높아지고 있다. 기대감과 함께 코로나19 바이러스 백신의 안전성에 대한 논란과 가짜뉴스가 끊임없이 지속되고 있다."                    
                //         },
                        
                //         {
                //             title: '무설탕, 무가당 음식물에는 당이 없다.',
                //             content: "건강에 대한 관심이 높아지면서 무가당, 무설탕 음식을 찾는 사람들도 많아지고 있다. 하지만 무가당, 무설탕 음료와 식품에 정말 당 성분이 없는 것인지에 대해 궁금한 사람들의 문의가 많다.",
                //         },
                //         {
                //             title: '에너지 음료를 마시면 공부가 잘 된다.',
                //             content: "잠을 쫓거나 집중력을 높이기 위해 커피나 에너지 음료를 마시는 학생들이 늘어나고 있다. 에너지 음료 시장도 커지고 있지만 그 효과에 대한 의문과 함께 건강 문제에 대한 우려가 커지고 있는 상황이다."

                //         },
                //     ],
                //     // 3nd page
                //     [
                //         {
                //             title: '운전면허증이 없는 사람도 자율주행차를 운전할 수 있다.',
                //             content: "과학기술의 발달과 함께 자율주행차에 대한 관심이 많아지고 있다. 이에 대해서 운전자의 역할을 어디까지로 볼 것인가, 운전면허증이 없어도 되는지에 대한 궁금증이 커지고 있다.",
                //         },
                //         {
                //             title: '전자레인지로 음식을 조리하면 영양소가 파괴된다.',
                //             content: "현대인들 간편식을 즐겨 먹으면서 전자레인지를 이용한 음식조리가 많아지고 있다. 음식 섭취의 편리함과 함께 영양소가 파괴되는 것이 아니냐는 불안감의 목소리도 커지고 있다.",
                //         }   
                //     ],
                // ]
            }
        },

        backToPlay: function() {
            this.$router.go(-1)
        }
    }
}
</script>

<style scoped>

/* pc */
@media screen and (min-width: 415px) {
    .layout_split {
        display:flex;
    }
    .main_area {
        width:100%;
        background-color:#e5e5e5
    }
    .upper_flex_container {
        display:flex;
        justify-content: space-around;
        margin-top:30px;
    }
    .lower_flex_container {
        display:flex;
        justify-content:space-around;
        margin-top:20px;
    }
    .mobile_margin {
        display: none;
    }
}


/* mobile */
@media screen and (max-width: 414px) {
    .layout_split {
        display:flex;
        flex-direction:column;
    }
    .main_area {
        width:100%;
        background-color:#e5e5e5
    }
    .upper_flex_container {
        display:flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        justify-items: center;
        margin:10px;
    }
    .lower_flex_container {
        display: flex;
        flex-direction: column;
        margin: 10px;
        align-items: center;
        justify-content: center;
        justify-items: center;
    }
    .mobile_margin {
        margin-bottom: 50px;
        opacity: 0;
    }
}

.black_label {
    padding-top: 10px;
    text-align: center;
    color: white;
    font-size: 24px;
    font-weight: 700;
    width: 180px;
    height: 58px;
    margin-left: auto;
    margin-right: auto;
    background-repeat: no-repeat;
    background-image:url("../assets/img/black_bg.png");
    background-size: 180px 58px;
}
.result_container {
    text-align: center;
    background: linear-gradient(#ffffff00 30px, white 30px 100%);
    padding-bottom: 20px;
    margin: 10px;
}
.result_value {
    font-size: 20px;
}
.result_list_value {
    font-size: 18px;
    text-align: left;
    margin: 5px;
    background-color: #eeeeee;
}


.btn_ok {
    text-align: center;
    width: 280px;
    padding: 10px;
    margin: 0px 10px;
    border: 2px solid black;
    font-weight: 700;
    font-size: 26px;
    color: black;
    cursor: pointer;
}
.btn_ok_active {
    box-shadow:3px 3px 3px grey;
    background-color: white;
}
.btn_container {
    margin-top: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
}

</style>
